export class MealService {
    Id: number;
    Balance: string;
    BreakFastALaCarte: string;
    BreakFastMeal: string;
    Date: Date;
    Deposits: string;
    LunchALaCarte: string;
    LunchMeal: string;
    Net: string;
    OtherALaCarte: string;
    OtherMeal: string;
    SnackALaCarte: string;
    SnackMeal: string;
    TotalPurchases: string;
    MealServiceDetailItems: MealServiceDetailItems[] = [];
    FromDate: Date;
    ToDate: Date;
}

export class MealServiceDetailItems {
    $id: number;
    Charge: string;
    Deposit: string;
    Item: string;
    ItemType: string;
    MealGroup: string;
    Processed: Date;
    TransactionType: string;
    fltAmount: number;
}

export class MealServiceFilter {
    FromDate: Date;
    ToDate: Date;
}

export class LunchMealChoice {
    Id: number;
    Date: Date;
    Choice: string;
    MonthlyLunchMenuChoices: MonthlyLunchMenuChoices[] = [];
}

export class MonthlyLunchMenuChoices {
    Id: number;
    Choice: string;
    ChoiceDescription: string
}